import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CalculateTableHeightService {
  private tableHeight: number;
  private screenHeight: number;
  private selector: string;
  private tableContainerClassName: string;

  private currentComponent: HTMLElement;

  /**
   * Calculate table height. Screen size - total height of additional elements excluding table container.
   * @param selector
   * @param tableContainerClassName
   */
  calculateTabletHeight(selector: string, tableContainerClassName: string): number {
    this.selector = selector;
    this.tableContainerClassName = tableContainerClassName;
    this.screenHeight = window.innerHeight;
    this.tableHeight = this.screenHeight - this.getTotalAdditionalHeight();
    return this.tableHeight;
  }

  private getTotalAdditionalHeight(): number {
    return this.getFixedElementsHeight() + this.getAdditionalElementHeight();
  }

  /**
   * Get total height of fixed elements: global header, footer, header row of the table,...
   */
  private getFixedElementsHeight(): number {
    let topNavHeight = (document.getElementsByClassName("fab-header")[0] as HTMLElement).offsetHeight;
    let footerHeight = (document.getElementById("remitos-footer") as HTMLElement).offsetHeight;
    let tableHeaderRowHeight = (document.querySelector("thead") as HTMLElement)?.offsetHeight;
    return topNavHeight + footerHeight + tableHeaderRowHeight;
  }

  /**
   * Get current component as HTMLElement using selector as tag name.
   * Then find all child nodes of current element that are not table container element to calculate additional height.
   * chileNodes[0] is the wrapper div element in each component.
   * Then convert from ChildNode type to HTMLElement type.
   * Finally, sum up the height of all additional elements.
   */
  private getAdditionalElementHeight(): number {
    // console.log(document.querySelector(`${this.selector}`))

    this.currentComponent = document.querySelector(`${this.selector}`) as HTMLElement;
    // console.log(this.currentComponent.childNodes[0].childNodes);

    return Array.from(this.currentComponent.childNodes[0].childNodes)
      .filter((node) => (node instanceof HTMLElement && node.className !== this.tableContainerClassName))
      .map((node) => node as HTMLElement)
      .map((el) => el.offsetHeight).reduce((sum, height) => sum + height, 0);
  }
}
